<template>
        <div class="dropdown d-inline-block btn-download">
            <button type="button" class="button" data-bs-toggle="dropdown">
                <i class="fa-solid fa-download"></i>
            </button>
            <ul class="dropdown-menu">
                <li v-for="(items,index) in dataList" :key="index"><a href="#">{{items.label}}</a></li>
            </ul>
        </div>
</template>
<script>
export default {
    name:"doemload-pdf",

     data() {
            return {
                dataList:[],
            }
     },
      mounted() {
           
     },
     methods:{
         loadDownloadView(downloadlist){
             const self = this;
            self.dataList = downloadlist;
         }
     }
}
</script>
